import { useState } from 'react';
import SnackbarContext from './Context';
import Snackbar from 'components/CncUI/Snackbar';

const SnackbarProvider = props => {
  const { children } = props;
  const [alert, setAlert] = useState({
    show: false,
    inline: true,
    position: 'top-center',
    duration: 4500,
    type: 'info',
    title: '',
    message: '',
    className: '',
    style: {},
  });
  const notify = data => {
    setAlert({ ...alert, show: false });
    setTimeout(
      setAlert({
        show: true,
        inline: true,
        position: 'top-center',
        duration: 4500,
        type: 'info',
        title: '',
        message: '',
        className: '',
        style: {},
        ...data,
      }),
      50,
    );
  };

  return (
    <>
      <Snackbar
        title={alert.title}
        open={alert.show}
        onClose={() => setAlert({ ...alert, show: false })}
        position={alert.position}
        hideDuration={alert.duration}
        inline={alert.inline}
        variant={alert.type}
        className={alert.className}
        style={alert.style}
        data-test-id={`Snackbar-message-${alert.type.toUpperCase()}`}
      >
        {alert.message}
      </Snackbar>
      <SnackbarContext.Provider value={notify}>
        {children}
      </SnackbarContext.Provider>
    </>
  );
};

export default SnackbarProvider;
